import {
  IGetDebtReceipts,
  IGetDebtReceiptsArgs,
  IGetDebtRecoveryRequests,
  IGetDebtRecoveryRequestsProps,
  IResponseError,
  IGeneratePaymentRequest,
  IGeneratePaymentRequestProps,
  IResendPaymentRequestProps,
  IResendPaymentRequest,
  IReGeneratePaymentRequestProps,
} from "./DebtRecoveryServices.dto";
import GeneralServices from "./GeneralServices";
import { CatchErrorType } from "./dto/response/CommonResponse.dto";

class DebtRecoveryServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;

    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getDebtReceipts = async ({
    loader,
    setLoading,
    mediatorCode,
    takerNif,
  }: IGetDebtReceiptsArgs): Promise<IGetDebtReceipts | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        isSlowProcess: true,
        endpoint: `debt-recovery/getDebtReceipts?takerNif=${takerNif}&mediatorCode=${mediatorCode}`,
      });

      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación de los datos de los recibos impagados."
      );
    }
  };

  generatePaymentRequest = async ({
    loader,
    setLoading,
    request,
  }: IGeneratePaymentRequestProps): Promise<IGeneratePaymentRequest | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading,
        loader,
        endpoint: "debt-recovery/generatePaymentRequest",
        data: request,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en el envío de petición de recobro.");
    }
  };

  getDebtRecoveryRequests = async ({
    loader,
    setLoading,
    mediatorCode,
    isPending,
    skip,
    take,
  }: IGetDebtRecoveryRequestsProps): Promise<IGetDebtRecoveryRequests | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `debt-recovery/getDebtRequests?mediatorCode=${mediatorCode}&isPending=${isPending}&skip=${skip}&take=${take}`,
      });

      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación de la tabla de Solicitudes de Recobro."
      );
    }
  };

  resendPaymentRequest = async ({
    loader,
    setLoading,
    request,
  }: IResendPaymentRequestProps): Promise<IResendPaymentRequest | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading,
        loader,
        endpoint: "debt-recovery/requestSending",
        data: request,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en el envío de petición de recobro.");
    }
  };

  reGeneratePaymentRequest = async ({
    loader,
    setLoading,
    request,
  }: IReGeneratePaymentRequestProps): Promise<IGeneratePaymentRequest | IResponseError> => {
    try {
      const response = await GeneralServices.post({
        setLoading,
        loader,
        endpoint: "debt-recovery/generatePaymentRequest",
        data: request,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(error, "Error en el envío de petición de recobro.");
    }
  };
}

export default new DebtRecoveryServices();
